import { forwardRef, useEffect, useImperativeHandle, useRef, useState } from "react";
import { config } from "../lib/config";

let scriptPromise;
function loadScript() {
  if (window.turnstile) return Promise.resolve();
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const s = document.createElement("script");
      s.src = "https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit";
      s.async = true;
      s.onload = resolve;
      s.onerror = reject;
      document.head.appendChild(s);
    });
  }
  return scriptPromise;
}

export const Turnstile = forwardRef(function Turnstile({ onToken, action }, ref) {
  const el = useRef(null);
  const widgetId = useRef(null);
  const cb = useRef(onToken);
  cb.current = onToken;
  const [error, setError] = useState("");

  useEffect(() => {
    let cancelled = false;
    loadScript()
      .then(() => {
        if (cancelled || !el.current) return;
        widgetId.current = window.turnstile.render(el.current, {
          sitekey: config.turnstileSiteKey,
          action,
          theme: "light",
          callback: (t) => { setError(""); cb.current(t); },
          "expired-callback": () => cb.current(null),
          "error-callback": () => { cb.current(null); setError("Security check could not load. Please refresh the page."); },
        });
      })
      .catch(() => setError("Security check could not load. Please check your connection."));
    return () => {
      cancelled = true;
      if (widgetId.current != null && window.turnstile) window.turnstile.remove(widgetId.current);
      widgetId.current = null;
    };
  }, [action]);

  useImperativeHandle(ref, () => ({
    reset: () => {
      cb.current(null);
      if (widgetId.current != null) window.turnstile?.reset(widgetId.current);
    },
  }));

  return (
    <div data-testid="cloudflare-turnstile" className="min-h-[65px]">
      <div ref={el} />
      {error && <p data-testid="turnstile-error" className="mt-1 text-xs text-[#A31828]">{error}</p>}
    </div>
  );
});
